import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import DataCacheService from '@/shared/services/DataCacheService';
import { SettingsQueryKey } from './queryKey';
export const useUpdateSsoSettings = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation((model) => api.base.put('/api/settings/Sso', model).then(res => res.data), {
        onSuccess: (result) => {
            if (!result)
                return;
            // The employee overview, 2FA hint and the security section read the provider from the data cache.
            const dataCache = DataCacheService.getDataCache();
            if (dataCache) {
                dataCache.ssoProvider = result.ssoProvider;
            }
            queryClient.setQueryData([SettingsQueryKey.SsoSettings], result);
        },
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
    return { updateSsoSettings: mutateAsync, isLoading };
};
